module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "askDetail"
  }, [_c('div', {
    staticClass: "mediaBox"
  }, [_c('div', {
    staticClass: "mb_span"
  }, [_c('img', {
    attrs: {
      "src": (_vm.item.user && _vm.item.user.avatar) || _vm.$state.defaultHead
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb_div"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('h3', [_c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.item.create_time))]), _vm._v(_vm._s(_vm.item.user && _vm.item.user.nickname))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "fr",
    class: {
      'red': _vm.item.answer_state == '未回复', 'success': _vm.item.answer_state == '已回复', 'orange': _vm.item.answer_state == '已填写内容未发送'
    }
  }, [_vm._v(_vm._s(_vm.item.answer_state))]), _vm._v(" "), _c('a', {
    staticClass: "tel blue",
    on: {
      "click": function($event) {
        _vm.util.callphone(_vm.item.user && _vm.item.user.tel)
      }
    }
  }, [_vm._v(_vm._s(_vm.item.user && _vm.item.user.tel || '　'))])])]), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.onLink('/ask_price_details?id=' + _vm.item.id)
      }
    }
  }, [_c('p', [_vm._v("幅宽：" + _vm._s(_vm.item.sku_width))]), _vm._v(" "), _c('p', [_vm._v("数量：" + _vm._s(_vm.item.buy_nums) + _vm._s(_vm.item.buy_unit_string))]), _vm._v(" "), _c('p', [_vm._v("印染要求：" + _vm._s(_vm.item.sku_printing))]), _vm._v(" "), _c('p', [_vm._v("交货期：" + _vm._s(_vm.item.trade_channel) + " 天")]), _vm._v(" "), _c('p', {
    class: {
      'red': _vm.item.is_tax == '含税'
    }
  }, [_vm._v(_vm._s(_vm.item.is_tax))]), _vm._v(" "), _c('p', [_vm._v("买" + _vm._s(_vm.item.sku_stage_string))])]), _vm._v(" "), (_vm.item.sku_images) ? _c('div', {
    staticClass: "img_box clearfix"
  }, _vm._l((_vm.item.sku_images), function(imgs, imgIndex) {
    return _c('em', {
      staticClass: "span_box"
    }, [_c('span', {
      style: ('background-image:url(' + imgs.compress_file_url + ')'),
      on: {
        "click": function($event) {
          _vm.showPreviewer(imgIndex)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sb_hidden"
    }, [_c('img', {
      attrs: {
        "src": imgs.compress_file_url.split(',w_')[0] + ',w_' + _vm.width
      }
    })])])
  })) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.plist
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1670e998"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/askDetail/askDetail.vue
// module id = 230
// module chunks = 28